import React from 'react'

import PrintRadioQuestion from './PrintRadioQuestion'
import PrintRadioQuestionExplanation from './PrintRadioQuestionExplanation'
import PrintCheckBoxQuestion from './PrintCheckBoxQuestion'
import PrintTextQuestion from './PrintTextQuestion'
import PrintNumericQuestion from './PrintNumericQuestion'
import * as answerService from "../services/answer-service"

export default class PrintQuestion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      allComments: []
    }
  }

  componentDidMount() {
    const { originalState } = this.props

    if (originalState && originalState.length > 0) {
      const { scanId } = originalState[0]
      if (scanId) {
        answerService
            .getComments(scanId)
            .then((allComments) => {
              this.setState({ allComments })
            })
            .catch((error) => {
              console.error('Error fetching comments:', error)
            })
      }
    }
  }

  render() {
    const { question, onChange, state, originalState, completed, answermap, isIntroQuestions, responseQuestions, collaborationresponse } = this.props
    const { allComments } = this.state

    if (!question) {
      return null
    }

    switch (question.optionType) {
      case 'RADIO':
        return (
            <PrintRadioQuestion
                key={question.id}
                data={question}
                state={state}
                originalState={originalState}
                completed={completed}
                answermap={answermap}
                isIntroQuestions={isIntroQuestions}
                isExtraQuestion={false}
                collaborationresponse={false}
                allComments={allComments}
            />
        )
      case 'RADIO_WITH_EXPLANATION':
        return (
            <PrintRadioQuestionExplanation
                key={question.id}
                data={question}
                state={state}
                originalState={originalState}
                onChange={(e, optionIds) => onChange(e, optionIds)}
                completed={completed}
                answermap={answermap}
                isIntroQuestions={isIntroQuestions}
                isExtraQuestion={true}
                responseQuestions={responseQuestions}
                collaborationresponse={collaborationresponse}
                allComments={allComments}
            />
        )
      case 'CHECKBOX':
        return (
            <PrintCheckBoxQuestion
                key={question.id}
                data={question}
                state={state}
                originalState={originalState}
                completed={completed}
                answermap={answermap}
                isIntroQuestions={isIntroQuestions}
                allComments={allComments}
            />
        )
      case 'TEXT':
        return (
            <PrintTextQuestion
                key={question.id}
                data={question}
                state={state}
                answermap={answermap}
                isIntroQuestions={isIntroQuestions}
                responseQuestions={responseQuestions}
                collaborationresponse={collaborationresponse}
                allComments={allComments}
            />
        )
      case 'NUMERIC':
        return (
            <PrintNumericQuestion
                key={question.id}
                data={question}
                state={state}
                originalState={originalState}
                answermap={answermap}
                isIntroQuestions={isIntroQuestions}
                allComments={allComments}
            />
        )
      case 'SELECT':
        return (
            <PrintNumericQuestion
                key={question.id}
                data={question}
                state={state}
                originalState={originalState}
                answermap={answermap}
                isIntroQuestions={isIntroQuestions}
                allComments={allComments}
            />
        )
      default:
        console.log('Er mist een optie: ' + question.optionType)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PrintQuestion.js